import styled from 'styled-components';

export const BoxContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 24px 20px 18px 20px;
  background: rgba(0, 0, 0, 0.175);
  border-radius: 10px;
`;

export const Container = styled.div<{ isLarge: boolean }>`
  margin-right: 16px;

  &:hover {
    ${BoxContent} {
      background: rgba(0, 0, 0, 0.5);
    }
  }

  :nth-child(odd) {
    margin-bottom: ${(props) => (props.isLarge ? '0' : '16')}px;
  }
`;

export const Box = styled.div<{ bgImage: string; isLarge: boolean; noImage: boolean }>`
  height: ${(props) => (props.isLarge ? '400' : '192')}px;
  width: 280px;
  border-radius: 10px;
  background: url(${(props) => props.bgImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: ${(props) => (props.noImage ? 'contain' : 'cover')};
`;

export const TopHalf = styled.div``;

export const Address = styled.div`
  width: 230px;

  p {
    line-height: 24px;
  }
`;

export const PriceContainer = styled.div`
  margin-top: 9px;
`;

export const Badge = styled.div`
  margin-top: 9px;
  position: initial;
  width: fit-content;
`;

export const View = styled.div`
  display: flex;
`;

export const Arrow = styled.div`
  margin-left: 6px;
`;
